import { createContext } from 'react';

export interface AppShellBounds {
  bottom: number;
  left: number;
  right: number;
  top: number;
}

export interface AppShellContextType {
  appShellBounds: AppShellBounds;
  mobileSearch: {
    close: () => void;
    isOpen: boolean;
    open: () => void;
  };
  setAppShellBounds: React.Dispatch<React.SetStateAction<AppShellBounds>>;
}

export const AppShellContext = createContext<AppShellContextType | null>(null);
